import { Fragment } from 'react';
import {
	ETIReportOverview,
	PDFTableProps,
	Project,
} from '../../../../utils/models';

import { formatTime } from '../../../../utils/utilities';
import { getETTestingColumns } from '../../../../utils/data';
import { APP_DATE_FORMAT } from '../../../../utils/constants';

import GridItem from '../general/gridItem';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';

type CurrentTestingReportProps = Pick<PDFTableProps, 'data'> &
	ETIReportOverview & {
		projectDetails: Project;
	};

const CurrentTestingReport = (props: CurrentTestingReportProps) => {
	return (
		<Fragment>
			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						<GridItem
							title="Inspection Standard:"
							value={props.inspectionStd}
						/>
					</div>

					<div className="col">
						<GridItem
							title="Acceptance Criteria:"
							value={props.acceptanceCriteria}
						/>
					</div>
				</div>
			</div>

			<div className="container-fluid overflow-hidden">
				<GridItem title="NDE Technique:" value={props.ndeTechnique} />
				<GridItem title="Procedure No:" value={props.procedureNo} />
			</div>

			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						<GridItem title="Equipment:" value={props.equipment} />
						<GridItem title="Probe:" value={props.probe} />
						<GridItem title="Probe Frequency:" value={props.probeFrequency} />
						<GridItem title="Scanning Level:" value={props.scanningLevel} />
					</div>

					<div className="col">
						<GridItem title="Serial No:" value={props.serialNo} />
						<GridItem title="Calibration Blk:" value={props.calibrationBlk} />
						<GridItem title="Sensitivity:" value={props.sensitivity} />
						<GridItem
							title="Calibrated:"
							value={formatTime(props.calibrated, APP_DATE_FORMAT)}
						/>
					</div>
				</div>
			</div>

			<div className="container-fluid overflow-hidden"></div>

			<PDFTablePage data={props.data} columns={getETTestingColumns()} />

			<div className="container-fluid overflow-hidden">
				<GridItem title="Remarks:" value={props.remarks} />
			</div>
		</Fragment>
	);
};

export default CurrentTestingReport;
